let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k9y9g")).then(() => parcelRequire('kpCj1'));